import { Component, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { contractModificationsWizardSteps } from 'src/app/models/wizard-enum';

@Component({
  selector: 'contract-modification-purpose',
  templateUrl: './request-purpose.component.html',
  styleUrls: ['./request-purpose.component.scss'],
  standalone: false,
})
export class RequestPurposeComponent {
  wizardStepsEnum = contractModificationsWizardSteps;

  @Input() contractModificationRequest: app.models.ContractModificationRequest;
  @Input() DICTIONARY_CONTRACT_MODIFICATION_TYPE: app.models.DictionaryContractModificationRequestType;
  @Input() DICTIONARY_REIMBURSEMENT_TYPE: app.models.DictionaryReimbursementType;
  @Input() contractModificationPurposeDatasource: app.models.DictionaryContractModificationRequestPurpose[];
  @Input() fourthQuestionFormGroup: FormGroup;

  @Input() nextStepHandler: any;
}
